//created by sudip
import { motion } from "framer-motion";

interface HeroMetricCardProps {
    title: string;
    value: string;
    change: string;
    accent: string;
    delay?: number;
}

export function HeroMetricCard({
    title,
    value,
    change,
    accent,
    delay = 0,
}: HeroMetricCardProps) {

    return (

        <motion.div
            initial={{
                opacity: 0,
                y: 20,
            }}
            animate={{
                opacity: 1,
                y: 0,
            }}
            transition={{
                duration: 0.55,
                delay,
            }}
            className="
                rounded-2xl
                border
                border-slate-200
                bg-white
                px-3
                py-4
                shadow-sm
                transition-all
                duration-300
                hover:-translate-y-1
                hover:shadow-lg
            "
        >

            <div className="flex items-center justify-between">

                <p className="text-sm font-medium text-slate-500">

                    {title}

                </p>

                <span
                    className="h-2.5 w-2.5 rounded-full"
                    style={{
                        backgroundColor: accent,
                    }}
                />

            </div>

            <h3 className="mt-4 text-2xl font-bold text-slate-900">

                {value}

            </h3>

            <div
                className="mt-4 inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold"
                style={{
                    backgroundColor: `${accent}18`,
                    color: accent,
                }}
            >

                {change}

            </div>

        </motion.div>

    );

}